import { useId } from 'react'
import useTableContext from '../../hooks/useTableContext'
import { AutocompleteUniselection, Icon } from '@yes.technology/react-toolkit'
import { useTranslation } from 'react-i18n-lite'
import {
  LayoutAutocompleteWrapper,
  FileExportActions,
  LayoutContainer
} from './LayoutAndReport.styles'
import useExportXLS from '../../hooks/useXLSData/useExportXLS'
import DownloaderLoading from 'report/components/DownloaderLoading'
import useExportPDF from 'report/hooks/useExportPDF/useExportPDF'

export default function LayoutAndReport() {
  const {
    mode,
    displayLayoutSelection,
    isShowPDFReports,
    isShowXLSReport,
    layoutClassificationUuid
  } = useTableContext()

  const { t } = useTranslation()

  const layoutSelectionLabelId = useId()

  const reportDownloadClasses = 'btn btn-link p-0'

  const { exportXLSReport, isLoading: isLoadingXLS } = useExportXLS()
  const { exportPDFReport, isLoading: isLoadingPDF } = useExportPDF({
    reportType: 'list',
    downloadType: 'single-pdf',
    layoutClassificationUuid
  })

  if (!isShowPDFReports && !isShowXLSReport) {
    return null
  }

  if (mode !== 'view' && !displayLayoutSelection) {
    return null
  }

  if (isLoadingXLS || isLoadingPDF) {
    return <DownloaderLoading />
  }

  return (
    <LayoutContainer>
      <FileExportActions>
        {isShowPDFReports && (
          <button
            type='button'
            className={reportDownloadClasses}
            onClick={exportPDFReport}
            title={t('data-tables.download-pdf-report')}
          >
            <Icon iconName='PDFFile' icSize='large' icColor='sanJuan' />
          </button>
        )}

        {isShowXLSReport && (
          <button
            type='button'
            className={reportDownloadClasses}
            onClick={exportXLSReport}
            title={t('data-tables.download-xls-report')}
          >
            <Icon iconName='ExcelFile' icSize='large' icColor='sanJuan' />
          </button>
        )}
      </FileExportActions>

      {displayLayoutSelection && (
        <LayoutAutocompleteWrapper>
          <div className='navigation-slider-title' id={layoutSelectionLabelId}>
            Layout
          </div>

          <AutocompleteUniselection
            aria-labelledby={layoutSelectionLabelId}
            options={[]}
            heightClass='semiSmall'
            disabled
            value=''
          />
        </LayoutAutocompleteWrapper>
      )}
    </LayoutContainer>
  )
}
